import { LivestreamGuessPanel } from "@/pages/home/livestream/LivestreamGuessPanel";

export function LivestreamPage() {
  return (
    <div className="page-stack">
      <LivestreamGuessPanel layout="room" />
    </div>
  );
}
